/* eslint-disable spire/export-styles */
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { COLORS, TYPOGRAPHY } from "@tecumseh/theme/design";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
    title: getCurrentPage(state).fields.title,
});

const enum fields {
    pageTitle = "pageTitle",
}
interface OwnProps extends WidgetProps {
    fields: {
        [x: string]: string;
        [fields.pageTitle]: string;
    };
}
type Props = OwnProps & ReturnType<typeof mapStateToProps>;

interface PageTitleStyles {
    title?: TypographyProps;
}

export const pageTitleStyles: PageTitleStyles = {
    title: {
        css: css`
            color: ${getColor("primary")};
            margin-bottom: 20px;
        `,
    },
};

const styles = pageTitleStyles;

const PageTitle: React.FunctionComponent<Props> = ({ fields, title }: Props) => (
    <Typography variant="h2" as="h1" data-test-selector="PageTitle" {...styles.title}>
        {fields.pageTitle !== "" ? fields.pageTitle : fields.overrideTitle || title}
    </Typography>
);

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(PageTitle),
    definition: {
        group: "Basic",
        icon: "heading",
        fieldDefinitions: [
            {
                name: fields.pageTitle,
                fieldType: "Translatable",
                editorTemplate: "TextField",
                defaultValue: ""
            },
        ]
    },
};

export default widgetModule;
